const FOGLIO_STATISTICHE_ID = "1_qjr6Pblf_nl9HF6yotjHOxJSXOVrJ_j3DQi-0GVLlc";
const NOME_FOGLIO = "TabellaSorgente";

async function getUltimaRiga(accessToken) {
  const url = `https://sheets.googleapis.com/v4/spreadsheets/${FOGLIO_STATISTICHE_ID}/values/${encodeURIComponent(NOME_FOGLIO + "!A:A")}`;
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  const data = await res.json();
  return (data.values || []).length;
}

async function leggiRiga(accessToken, rigaNum) {
  const url = `https://sheets.googleapis.com/v4/spreadsheets/${FOGLIO_STATISTICHE_ID}/values/${encodeURIComponent(NOME_FOGLIO + `!A${rigaNum}:R${rigaNum}`)}`;
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  const data = await res.json();
  return data.values?.[0] || [];
}

async function cercaRigaPerTitolo(accessToken, titolo) {
  const url = `https://sheets.googleapis.com/v4/spreadsheets/${FOGLIO_STATISTICHE_ID}/values/${encodeURIComponent(NOME_FOGLIO + "!H:H")}`;
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  const data = await res.json();
  const righe = data.values || [];
  for (let i = 1; i < righe.length; i++) {
    if (righe[i][0] === titolo) return i + 1;
  }
  return -1;
}

async function aggiornaRiga(accessToken, rigaNum, valori) {
  const url = `https://sheets.googleapis.com/v4/spreadsheets/${FOGLIO_STATISTICHE_ID}/values/${encodeURIComponent(NOME_FOGLIO + `!A${rigaNum}:R${rigaNum}`)}?valueInputOption=USER_ENTERED`;
  const res = await fetch(url, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ values: [valori] }),
  });
  return res.json();
}

async function appendRiga(accessToken, valori) {
  const url = `https://sheets.googleapis.com/v4/spreadsheets/${FOGLIO_STATISTICHE_ID}/values/${encodeURIComponent(NOME_FOGLIO + "!A:R")}:append?valueInputOption=USER_ENTERED&insertDataOption=INSERT_ROWS`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ values: [valori] }),
  });
  return res.json();
}

async function cancellaRiga(accessToken, rigaNum) {
  const url = `https://sheets.googleapis.com/v4/spreadsheets/${FOGLIO_STATISTICHE_ID}:batchUpdate`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      requests: [{
        deleteDimension: {
          range: {
            sheetId: 0,
            dimension: "ROWS",
            startIndex: rigaNum - 1,
            endIndex: rigaNum,
          }
        }
      }]
    }),
  });
  return res.json();
}

function formatDataITA(dataISO) {
  if (!dataISO) return "";
  const [y, m, d] = dataISO.split("-");
  return `${d}/${m}/${y}`;
}

function calcolaDurataOre(evento) {
  if (evento.durataGiorni > 1 && evento.giornate?.length > 0) {
    let totaleMinuti = 0;
    for (const g of evento.giornate) {
      if (g.oraInizio && g.oraFine) {
        const [hI, mI] = g.oraInizio.split(":").map(Number);
        const [hF, mF] = g.oraFine.split(":").map(Number);
        totaleMinuti += (hF * 60 + mF) - (hI * 60 + mI);
      }
    }
    return totaleMinuti > 0 ? (totaleMinuti / 60).toFixed(2) : "";
  } else {
    if (evento.oraInizio && evento.oraFine) {
      const [hI, mI] = evento.oraInizio.split(":").map(Number);
      const [hF, mF] = evento.oraFine.split(":").map(Number);
      const minuti = (hF * 60 + mF) - (hI * 60 + mI);
      return minuti > 0 ? (minuti / 60).toFixed(2) : "";
    }
    return evento.durata || "";
  }
}

function tipoEventoLeggibile(tipoEvento) {
  if (tipoEvento === "online") return "Remoto";
  if (tipoEvento === "ibrido") return "Ibrido";
  if (tipoEvento === "presenza") return "In presenza";
  return tipoEvento || "";
}

function risolviNomi(ids, mappa) {
  if (!ids) return "";
  const arr = Array.isArray(ids) ? ids : [ids];
  return arr.map((id) => mappa[id] || id).join(", ");
}

export async function sincronizzaEvento(accessToken, evento, clientiMap, tipologieMap, tecnologieMap) {
  try {
    const nomeCliente = clientiMap[evento.clienteId] || evento.clienteNomeStorico || "";

    const dataRif = evento.durataGiorni > 1
      ? evento.giornate?.[0]?.dataInizio
      : evento.dataInizio || evento.data;

    const oraInizio = evento.durataGiorni > 1
      ? evento.giornate?.[0]?.oraInizio || ""
      : evento.oraInizio || "";

    const durataOre = calcolaDurataOre(evento);
    const dataFormattata = formatDataITA(dataRif);

    const nomeTipologia = risolviNomi(evento.tipologiaEvento, tipologieMap);
    const nomeTecnologia = risolviNomi(evento.tecnologie, tecnologieMap);

    const rigaEsistente = await cercaRigaPerTitolo(accessToken, evento.titolo || "");

    if (rigaEsistente > 0) {
      const rigaAttuale = await leggiRiga(accessToken, rigaEsistente);

      const valori = [
        rigaAttuale[0] || `=ARRAY_CONSTRAIN(ARRAYFORMULA(INDIRECT("A"&ROW()-1)+1); 1; 1)`,
        dataFormattata,
        rigaAttuale[2] || `=CHOOSE(WEEKDAY(B${rigaEsistente});"domenica";"lunedì";"martedì";"mercoledì";"giovedì";"venerdì";"sabato")`,
        nomeCliente,
        evento.durataGiorni || 1,
        oraInizio,
        durataOre,
        evento.titolo || "",
        nomeTipologia,
        nomeTecnologia,
        tipoEventoLeggibile(evento.tipoEvento),
        "", "", "", "", "",
        `=YEAR(TabellaSorgente!$B${rigaEsistente})`,
        `=MONTH(TabellaSorgente!$B${rigaEsistente})`,
      ];

      await aggiornaRiga(accessToken, rigaEsistente, valori);
      console.log("Riga aggiornata su Sheets:", evento.titolo);

    } else {
      const ultimaRiga = await getUltimaRiga(accessToken);
      const nuovaRiga = ultimaRiga + 1;

      const valori = [
        `=ARRAY_CONSTRAIN(ARRAYFORMULA(INDIRECT("A"&ROW()-1)+1); 1; 1)`,
        dataFormattata,
        `=CHOOSE(WEEKDAY(B${nuovaRiga});"domenica";"lunedì";"martedì";"mercoledì";"giovedì";"venerdì";"sabato")`,
        nomeCliente,
        evento.durataGiorni || 1,
        oraInizio,
        durataOre,
        evento.titolo || "",
        nomeTipologia,
        nomeTecnologia,
        tipoEventoLeggibile(evento.tipoEvento),
        "", "", "", "", "",
        `=YEAR(TabellaSorgente!$B${nuovaRiga})`,
        `=MONTH(TabellaSorgente!$B${nuovaRiga})`,
      ];

      await appendRiga(accessToken, valori);
      console.log("Nuova riga aggiunta su Sheets:", evento.titolo);

      // Cancella la riga extra che Sheets crea automaticamente
      const ultimaRigaDopoInsert = await getUltimaRiga(accessToken);
      const rigaExtraValori = await leggiRiga(accessToken, ultimaRigaDopoInsert);
      if (rigaExtraValori && rigaExtraValori.length > 0 && !rigaExtraValori[7]) {
        await cancellaRiga(accessToken, ultimaRigaDopoInsert);
        console.log("Riga extra cancellata:", ultimaRigaDopoInsert);
      }
    }
  } catch (error) {
    console.error("Errore sincronizzazione Sheets:", error);
  }
}